import { Coins, GlobeIcon, GlobeLock, LayoutGrid, LogInIcon, MessageSquareMore, Users, Currency, IndianRupee, BookUp2, ShieldEllipsis, ChartColumnBig, BotMessageSquare, ArrowRightLeft, Wallet, Megaphone } from "lucide-react";

const roleOfUser = sessionStorage.getItem('role');
const permissedPages = JSON.parse(sessionStorage.getItem('permission')) ? JSON.parse(sessionStorage.getItem('permission')) : [];



export const allChildren = [
    {
        id: 'applications',
        title: 'Applications',
        type: 'group',
        icon: <LayoutGrid size={20} />,
        translate: 'APPLICATIONS',
        children: [
            {
                title: "Dashboard",
                type: "item",
                icon: <LayoutGrid size={20} />,
                link: "/dashboard",
                Children: [],
            },
            {
                title: "User Management",
                type: "collapse",
                icon: <Users size={20} />,
                Children: [
                    {
                        title: "User List",
                        type: "item",
                        event: "user-management",
                        link: "/user-management",
                    },
                    {
                        title: "Delete requests",
                        type: "item",
                        event: "user-management",
                        link: "/deleted-Account",
                    },
                    {
                        title: "Deleted Accounts History",
                        type: "item",
                        event: "user-management",
                        link: "/deleted-Account-history",
                    },

                    {
                        title: "Blocked Users",
                        type: "item",
                        event: "user-management",
                        link: "/admin-blocked-users",
                    },
                    {
                        title: "Temporary Blocked Users",
                        type: "item",
                        event: "user-management",
                        link: "/blocked-users",
                    },

                ],
            },
            {
                title: "IP Management",
                type: "collapse",
                icon: <GlobeLock size={20} />,
                Children: [
                    {
                        title: "WhiteListed IP",
                        icon: <GlobeIcon size={20} />,
                        type: "item",
                        event: "Allowed IP",
                        link: "/allowed-ips",
                    },
                    {
                        title: "Blocked IP",
                        icon: <GlobeLock size={20} />,
                        type: "item",
                        event: "Blocked IP",
                        link: "/blocked-ips",
                    },

                ],
            },

            {
                title: "Login History",
                type: "item",
                icon: <LogInIcon size={20} />,
                link: "/login-history",
                Children: [],
            },
            {
                title: "Homepage Management",
                type: "collapse",
                icon: <MessageSquareMore size={20} />,
                Children: [
                    {
                        title: "Banner",
                        type: "item",
                        event: "homepageManagement",
                        link: "/banner",
                    },
                    {
                        title: "Features",
                        type: "item",
                        event: "homepageManagement",
                        link: "/features",
                    },
                    {
                        title: "Cards List",
                        type: "item",
                        event: "homepageManagement",
                        link: "/card-list",
                    },
                    {
                        title: "About Us",
                        type: "item",
                        event: "homepageManagement",
                        link: "/about",
                    },
                    {
                        title: "Download Roupay",
                        type: "item",
                        event: "homepageManagement",
                        link: "/download",
                    },
                    {
                        title: "CMS",
                        type: "item",
                        event: "homepageManagement",
                        link: "/cms",
                    },
                    {
                        title: "FAQ",
                        type: "item",
                        event: "FaqManagement",
                        link: "/faq",
                    },
                    {
                        title: "Card-Agreement",
                        type: "item",
                        event: "CardManagement",
                        link: "/card-content",
                    },
                ],
            },

            {
                title: "Fee Management",
                type: "item",
                icon: <Coins size={20} />,
                link: "/fee-management",
                Children: [],
            },
            {
                title: "Receive Management",
                type: "collapse",
                icon: <BookUp2 size={20} />,
                Children: [
                    {
                        title: "BNB",
                        type: "item",
                        event: "Receive Management",
                        link: "/receive/BNB",
                    },
                    {
                        title: "ETH",
                        type: "item",
                        event: "Receive Management",
                        link: "/receive/ETH",
                    },
                    {
                        title: "TRX",
                        type: "item",
                        event: "Receive Management",
                        link: "/receive/TRX",
                    },

                    {
                        title: "POL",
                        type: "item",
                        event: "Receive Management",
                        link: "/receive/POL",
                    },

                    {
                        title: "SOL",
                        type: "item",
                        event: "Receive Management",
                        link: "/receive/SOL",
                    },

                    {
                        title: "ROU",
                        type: "item",
                        event: "Receive Management",
                        link: "/receive/ROU",
                    },

                ],
            },

            {
                title: "Referral Management",
                type: "collapse",
                icon: <IndianRupee size={20} />,
                Children: [
                    {
                        title: "Reward Management",
                        type: "item",
                        event: "History",
                        link: "/referralreward",
                    },
                    {
                        title: "Reward Update History",
                        type: "item",
                        event: "Referral History",
                        link: "/admin-reward-edit-history",
                    },
                    {
                        title: "Referral History",
                        type: "item",
                        event: "Referral History",
                        link: "/totalreferralhistory",
                    },
                    {
                        title: "Cashback History",
                        type: "item",
                        event: "Cashback History",
                        link: "/cashback-history",
                    },
                    {
                        title: "Cashback Missed History",
                        type: "item",
                        event: "Cashback Missed History",
                        link: "/cashback-missed",
                    },
                    {
                        title: "Reward Failed History",
                        type: "item",
                        event: "Referral Pending",
                        link: "/reward-pending",
                    },
                ],
            },
            {
                title: "Card Management",
                type: "collapse",
                icon: <MessageSquareMore size={20} />,
                Children: [
                    {
                        title: "Card Created History",
                        type: "item",
                        event: "CardDepositHistory",
                        link: "/CardDepositHistory",
                    },
                    {
                        title: "Topup History",
                        type: "item",
                        event: "TopupHistory",
                        link: "/TopupHistory",
                    },
                    {
                        title: "Card Spend History",
                        type: "item",
                        event: "CardSpendHistory",
                        link: "/CardSpendHistory",
                    },
                    {
                        title: "Card Refund History",
                        type: "item",
                        event: "CardRefundHistory",
                        link: "/refund-history",
                    },


                ],
            },

            {
                title: "Send Management",
                type: "collapse",
                icon: <Currency size={20} />,
                Children: [
                    {
                        title: "BNB",
                        type: "item",
                        event: "Send Management",
                        link: "/Send/BNB",
                    },
                    {
                        title: "ETH",
                        type: "item",
                        event: "Send Management",
                        link: "/Send/ETH",
                    },
                    {
                        title: "TRX",
                        type: "item",
                        event: "Send Management",
                        link: "/Send/TRX",
                    },
                    {
                        title: "SOL",
                        type: "item",
                        event: "withdrawManagement",
                        link: "/Send/SOL",
                    },


                    {
                        title: "POL",
                        type: "item",
                        event: "Send Management",
                        link: "/Send/POL",
                    },
                    {
                        title: "ROU",
                        type: "item",
                        event: "Send Management",
                        link: "/Send/ROU",
                    },

                ],
            },






            {
                title: "Admin Fee Management",
                type: "item",
                icon: <Wallet size={20} />,
                link: "/admin-fee",
            },
            {
                title: "Internal Transfer History",
                type: "item",
                icon: <ArrowRightLeft size={20} />,
                link: "/internaltransactionhistory",
            },


            {
                title: "Sub Admin",
                type: "item",
                icon: <ShieldEllipsis size={20} />,
                link: "/SubAdmin",
                Children: [],
            },
            {
                title: "Support Ticket",
                type: "collapse",
                icon: <BotMessageSquare size={20} />,
                Children: [

                    {
                        title: "Category Management",
                        type: "item",
                        event: "Category",
                        link: "/ticket-category",
                    },
                    {
                        title: "Support Ticket History",
                        type: "item",
                        event: "Ticket History",
                        link: "/support",
                    },
                ],
            },

            {
                title: "Chart currency",
                type: "item",
                icon: <ChartColumnBig size={20} />,
                link: "/Chartcurrency",
                Children: [],
            },
        ]
    }
];

let filteredData = allChildren;

if (roleOfUser === 'subadmin' && permissedPages.length > 0) {
    const defaultItems = ['Dashboard', 'Security Settings'];

    filteredData = allChildren.map(group => ({
        ...group,
        children: (group.children || []).filter(item =>
            [...permissedPages.map(p => p.title), ...defaultItems].includes(item.title)
        ),
    }));
}

const childrenToShow = permissedPages.length === 0 ? allChildren[0] : filteredData[0];

const MeniItems = [
    childrenToShow,
];
export default MeniItems;


